import { PensionProductCode, UnitCategoryCode } from 'funds-model';

export enum ProductType {
  funds = "FUNDS",
  ike = "IKE",
  ikze = "IKZE",
}

interface Product {
  unitCategory: UnitCategoryCode;
  productCode?: PensionProductCode;
  minimalAmount: number;
  initialAmount: number;
  moventumCode: string;
}

export const PRODUCTS: Record<ProductType, Product> = {
  [ProductType.funds]: {
    unitCategory: UnitCategoryCode.A,
    minimalAmount: 200,
    initialAmount: 500,
    moventumCode: 'basic',
  },
  [ProductType.ike]: {
    unitCategory: UnitCategoryCode.K,
    productCode: PensionProductCode.ike,
    minimalAmount: 50,
    initialAmount: 200,
    moventumCode: 'IKE',
  },
  [ProductType.ikze]: {
    unitCategory: UnitCategoryCode.K,
    productCode: PensionProductCode.ikze,
    minimalAmount: 50,
    initialAmount: 200,
    moventumCode: 'IKZE',
  }
};

export { UnitCategoryCode };
